import EditActivityDurationModal from './EditActivityDurationModal'

export default EditActivityDurationModal
